import SelectComponent from "@via/components/select/select.tsx";
import { ContainerTypeOptions } from "@via/pages/account/profile/run-environments/run-environment-form/run-environment-constants.ts";
import { ContainerType, type ProfileClusterForClient } from "common";
import { type JSX } from "react";
import { type UseFormRegister } from "react-hook-form";

export const containerCardSummary = (params: {
  selectedContainerType: ContainerType;
  containerOptions?: string | null;
}): string => {
  const type =
    ContainerTypeOptions.find(o => o.value === params.selectedContainerType)
      ?.label ?? params.selectedContainerType;
  return params.containerOptions?.trim()
    ? `${type}, ${params.containerOptions.trim()}`
    : type;
};

export function ContainerCard({
  register,
  selectedContainerType,
  onContainerTypeChange,
}: {
  register: UseFormRegister<ProfileClusterForClient>;
  selectedContainerType: ContainerType;
  onContainerTypeChange: (option: any) => void;
}): JSX.Element {
  return (
    <>
      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Container Type
        </label>
        <div className="mt-2" data-testid="container-type">
          <SelectComponent
            name="containerType"
            onChange={onContainerTypeChange}
            value={ContainerTypeOptions.find(
              ({ value }) => value === selectedContainerType
            )}
            options={ContainerTypeOptions}
            enableClear={false}
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Default Container Options (optional)
        </label>
        <div className="mt-2" data-testid="container-options">
          <input
            {...register("containerOptions")}
            type="text"
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder={`e.g. --bind /data:/data`}
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          Singularity Cache Folder
        </label>
        <div className="mt-2">
          <input
            {...register("singuCache")}
            type="text"
            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            placeholder="Your Singularity Cache Folder"
          />
        </div>
      </div>
    </>
  );
}
